import {
    Component, OnInit, AfterViewInit, AfterContentInit, ViewChild, ViewChildren, NgModule, Sanitizer,
    SimpleChanges, OnChanges, SecurityContext,
    Directive, ElementRef, HostListener, HostBinding, Input, Output, ViewEncapsulation, EventEmitter
} from '@angular/core';

import { ExamPlayerService } from '../_services/ExamPlayerService';
declare var HotSpotH5: any;
declare var FunctionCall: any, InitializeObjects: any;
declare var mnClient: any, mnLeftLogo: any, mnRightLogo: any, RB_UIMgnt: any,
    putOnWait: any, HotSpotHtml5: any, Test: any, TestFunctions: any, Navigation: any, CloseTest: any, objSequenceSrcClass: any, Summary: any, SetUI_Controls: any, InitializeMainJS: any,hlrUpdateTimeAvail: any;
import { TaketestComponent } from './app.taketest'

/* User defined directives */
@Directive({
    selector: '[sectionDetails]'
})
export class SectionDetailsDirective {
    @Input('sectionDetails') section: any;
    constructor(private eleRef: ElementRef) { }

}

@Directive({
    selector: '[funCallDraggable]'
})

export class FunCallDraggableDirective {
    @Input('funCallDraggable') item: any;

    constructor(private eleRef: ElementRef) { }

    @HostListener('click', ['$event']) onClick($event) {
        FunctionCall(48, this.eleRef.nativeElement, 2, 3, '');
    }

    @HostListener('dragover', ['$event']) onDragOver($event) {
        FunctionCall(40, '', '', '', event);
        $(this.eleRef.nativeElement).removeClass("sequnce_drag")
    }
    @HostListener('ondrop', ['$event']) onDrop($event) {
        FunctionCall(42, this.eleRef.nativeElement, 2, '', $event);
    }
    @HostListener('dragenter', ['$event']) onDragEnter($event) {
        $(this.eleRef.nativeElement).addClass("sequnce_drag")
        FunctionCall(43, '', '', '', event);
    }


}
@Directive({
    selector: '[funCallGuid]'
})
export class FunCallGuidDirective {
    @Input('funCallGuid') item: any;
    @Input('first') value: any;
    constructor(private eleRef: ElementRef) { }
    @HostListener('dragstart', ['$event']) onDragStart($event) {
        FunctionCall(this.value, this.eleRef.nativeElement, this.item.ID, '', $event);
    }

}


@Directive({
    selector: '[funCall]'
})

export class FunCallDirective implements OnInit {
    @Input('funCall') item: any;
    @Input('choiceItem') choiceItem: any;
    @Input('type') type: any;
    constructor(private eleRef: ElementRef) { }

    @HostListener('click', ['$event']) onClick($event) {
        if (this.item.CorrectOptions != null && this.item.CorrectOptions.length > 0)
            return false;
        if (this.type == '1')
            $('input[type=radio]', this.eleRef.nativeElement).attr("checked", "checked");
        if (this.item.QType == 'Multiple Response Static') {
            if ($("input[type='checkbox'][question='true']:checked", Test.QuestionList[Test.TestInfo.CurrentPageNumber - 1]).length > this.item.QuestionAttributes.QuestionInfo.MaxChoiceSelection) {
                Summary.ShowMessage(["Choice Validation", "You can select max " + this.item.QuestionAttributes.QuestionInfo.MaxChoiceSelection + " choices"])
                $(this.eleRef.nativeElement).prop("checked", false);
                return;
            }
            FunctionCall(19, this.eleRef.nativeElement, this.item.QuestionAttributes.QuestionInfo.MaxChoiceSelection, 'hdnMaxChk_' + this.choiceItem.Ident)
        }
        else if (this.item.QType.toLocaleLowerCase() == 'multiple choice static')
            FunctionCall(11, this.eleRef.nativeElement)
        else
            FunctionCall(11, element);

        if (this.type == 'choicespan') {
            var element;
            if ($('input[type=radio]', $(this.eleRef.nativeElement)).length > 0)
                element = $('input[type=radio]', $(this.eleRef.nativeElement))[0];
            else if ($('input[type=checkbox]', $(this.eleRef.nativeElement)).length > 0)
                element = $('input[type=checkbox]', $(this.eleRef.nativeElement))[0];
            else if ($('input[type=checkbox]', $(this.eleRef.nativeElement.parentElement)).length > 0)
                element = $('input[type=checkbox]', $(this.eleRef.nativeElement.parentElement))[0];
            if ($(element).prop("checked") == false)
                $(element).prop("checked", true);
            FunctionCall(11, element);
        }
        else {
            let cntrl = $("input[type='radio'],[type='checkbox']", this.eleRef.nativeElement)
            $(cntrl).prop("checked", true);
            if (cntrl.length > 0)
                FunctionCall(11, cntrl[0]);
            else
                FunctionCall(11, this.eleRef.nativeElement);
            //FunctionCall(11, cntrl[0]);
        }
        if ($("input[type='checkbox'][question='true']:checked", this.eleRef.nativeElement.parentElement).length > this.item.QuestionAttributes.QuestionInfo.MaxChoiceSelection) {
            Summary.ShowMessage(["Choice Validation", "You can select max " + this.item.QuestionAttributes.QuestionInfo.MaxChoiceSelection + " choices"])
            $(element).prop("checked", false);
            return;
        }
        event.stopPropagation();
    }
    @HostListener('mouseenter') onMouseEnter() {

    }

    @HostListener('mouseleave') onMouseLeave() {

    }
    ngOnInit() {
        $(this.eleRef.nativeElement).attr({ 'value': this.choiceItem.Ident });
    }

}

//Hotspot questions

@Directive({
    selector: '[HotspotEvents]'
})

export class HotspotEventsDirective {
    @Input('HotspotEvents') item: any;
    @Input('qtype') value: any;
    constructor(private eleRef: ElementRef) { }
    @HostListener('click', ['$event']) onClick($event) {
        switch (this.value) {
            case 'hsmrs':
                HotSpotH5.selectedhotspot(this.eleRef.nativeElement + ',' + '"hsmrq"' + ',' + '"hdnspotselected_' + this.item.ID + '"' + ',' + '"#a9a9a9"');
                break;
            case 'hsmcq':
                HotSpotH5.selectedhotspot(this.eleRef.nativeElement + ',' + '"HSMCQ"' + ',' + '"hdnspotselected_' + this.item.ID + '"' + ',' + '"#a9a9a9"');
                break;
        }
    }


}

//Image Labeling Choice Events
@Directive({
    selector: '[ImageLabelingOptionEvents]'
})

export class ImageLabelingOptionEventsDirective {
    @Input('ImageLabelingOptionEvents') choice: any;
    constructor(private eleRef: ElementRef) { }
    @HostListener('click', ['$event']) onClick($event) {
        FunctionCall(49, this.eleRef.nativeElement.id, 0, '', $event)
    }

}


@Directive({
    selector: '[ImageLabelingChoiceEvents]'
})

export class ImageLabelingChoiceEventsDirective {
    @Input('ImageLabelingChoiceEvents') choice: any;
    @Input('ImageLabelingChItm') item: any;
    constructor(private eleRef: ElementRef) { }
    @HostListener('click', ['$event']) onClick($event) {
        if ($("#" + this.choice.ID) != null && $("#" + this.choice.ID)[0].nextSibling.nodeName == "#text") $($("#" + this.choice.ID)[0].nextSibling).remove();
        FunctionCall(49, this.eleRef.nativeElement.id, 1, '', $event)
    }
    ngOnInit() {
        try {
            if (this.item.UserRepsonse != null) {
                for (var res = 0; res < this.item.UserRepsonse.length; res++) {
                    if (this.choice.ID == this.item.UserRepsonse[res].split(':')[0])
                        this.eleRef.nativeElement.setAttribute('selectedqid', this.item.ID + "IMGL" + this.choice.Ident);
                }
            }
        }
        catch (ex) { }
    }
}
@Directive({
    selector: '[ImageLabelingChoiceanswerEvents]'
})

export class ImageLabelingChoiceanswerEventsDirective {
    @Input('ImageLabelingChoiceanswerEvents') choice: any;
    @Input('ImageLabelingItem') item: any;
    constructor(private eleRef: ElementRef) { }
    @HostListener('click', ['$event']) onClick($event) {
        if ($("#" + this.choice.ID) != null && $("#" + this.choice.ID)[0].nextSibling.nodeName == "#text") $($("#" + this.choice.ID)[0].nextSibling).remove();
        FunctionCall(49, this.choice.ID, 1, '', $event)

    }

    ngOnInit() {
        try {
            if (this.item.UserRepsonse != null) {
                for (var res = 0; res < this.item.UserRepsonse.length; res++) {
                    if (this.choice.ID == this.item.UserRepsonse[res].split(':')[0]) {
                        $(this.eleRef.nativeElement).html(this.item.UserRepsonse[res].split(':')[1]);
                        $(this.eleRef.nativeElement).addClass('AnswerOptionSelected');
                    }
                }
            }
        }
        catch (ex) { }
    }
}
@Directive({
    selector: '[funDiv]'
})
export class FunDivDirective implements OnInit {
    @Input('funDiv') item: any;
    constructor(private eleRef: ElementRef) { }
    @HostListener('click', ['$event']) onClick($event) {
        FunctionCall(11, this.eleRef.nativeElement);
    }
    ngOnInit() {
    }
}

@Directive({
    selector: '[SectionAnchor]'
})
export class SectionAnchorDirective implements OnInit {
    @Input('SectionAnchor') section: any;
    constructor(private elRef: ElementRef) { }
    ngOnInit() {
        $(this.elRef.nativeElement).attr("sectionid", "AMS_" + this.section.SectionID); $(this.elRef.nativeElement).attr("sectiontitle", this.section.SectionName);
    }
    @HostListener('click', ['$event']) onClick($event) {
        FunctionCall(12, this, $event);
    }
}
@Directive({
    selector: '[intializeScroll]'
})
export class IntializeScrollDirective implements AfterViewInit {
    @Input('intializeScroll') section: any;
    constructor(private eleRef: ElementRef) { }
    ngAfterViewInit() {
        if (typeof (RB_UIMgnt) != "undefined") RB_UIMgnt.InitalizeScrollForNavigationPanel();
    }
}

@Directive({
    selector: '[constructLi]'
})
export class ConstructLiDirective implements OnInit, AfterViewInit {
    @Input('constructLi') ques: any;
    @Input('first') Quesindex: any;
    @Input('secInxValue') sectionIndex: any;
    @Input('secDetail') SectionDetailsList: any;
    @Input('second') Concatvalue: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {

        if (this.sectionIndex == 0) {
            $(this.eleRef.nativeElement).attr({ "id": this.Concatvalue + (this.Quesindex + 1) });
            $(this.eleRef.nativeElement.parentElement).attr({ "title": "Click to view the page " + (this.Quesindex + 1) });
        }
        else {
            var totQuesCount = 0;
            for (var ind = 0; ind < this.sectionIndex; ind++) {
                totQuesCount = totQuesCount + this.SectionDetailsList[ind].QuestionCount;
            }
            if (typeof (this.Concatvalue) != "undefined" && this.Concatvalue != "")
                $(this.eleRef.nativeElement).attr({ "id": this.Concatvalue + (totQuesCount + this.Quesindex + 1) })
            else {
                this.eleRef.nativeElement.parentElement.innerHTML = (totQuesCount + this.Quesindex + 1);
                $(this.eleRef.nativeElement.parentElement).attr({ "title": "Click to view the page " + (totQuesCount + this.Quesindex + 1) })
            }
        }
    }
    ngAfterViewInit() {
    }
}
//constructMatchingDND
@Directive({
    selector: '[constructMatchingDND]'
})
export class constructMatchingDNDDirective implements OnInit {
    @Input('constructMatchingDND') item: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        try {
            var options = [];
            for (var op = 0; op < this.item.Choices.length; op++) {
                if (op == 0) options = this.item.Choices[op].Options;
                options[op].choiceID = this.item.Choices[op].ID;
            }
            this.item.options = options;
        }
        catch (e) { }
    }

}

// Sets the element's innerHTML to a sanitized version of [safeHtml]
@Directive({ selector: '[safeHtml]' })
export class SanitizeHtmlDirective {
    @Input() safeHtml: string;
    constructor(private elementRef: ElementRef, private sanitizer: Sanitizer) { }
    ngOnChanges(changes: SimpleChanges): any {
        try {
            if ('safeHtml' in changes) {
                this.elementRef.nativeElement.innerHTML = this.safeHtml;
                this.sanitizer.sanitize(SecurityContext.HTML, this.safeHtml);
            }
        }
        catch (e) { }
    }
}

@Directive({
    selector: '[choiceCustom]'
})
export class ChoiceCustomDirective implements OnInit {
    @Input('choiceCustom') choice: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        $(this.eleRef.nativeElement).attr({ "value": this.choice.Ident });
    }

}

@Directive({
    selector: '[questionDiv]'
})
export class QuestionDivDirective implements OnInit, AfterViewInit {
    constructor(private elRef: ElementRef,public assessmentService: ExamPlayerService) { }
    @Input('questionDiv') item: any;
    @Input('first') quesNo: any;
    @Input('second') test: any;
    ngOnInit() {
        try {
            try {
                if (this.item.QuestionAttributes != "" && this.item.QuestionAttributes != null && typeof (this.item.QuestionAttributes) != 'undefined')
                    this.item.QuestionAttributes = JSON.parse(this.item.QuestionAttributes);
                if (typeof (this.item.PInfo) != 'undefined' && this.item.PInfo != null && this.item.PInfo.PassageXml != null && this.item.PInfo.PassageXml.length > 0 && this.item.PInfo.PassageXml.indexOf('<![CDATA[') > 0)
                    this.item.PInfo.PassageXml = this.item.PInfo.PassageXml.replace('<![CDATA[', '').replace(']]>', '');
                if (typeof (this.item.PInfo) != 'undefined' && this.item.PInfo != null && this.item.PInfo.Direction != null && this.item.PInfo.Direction.length > 0 && this.item.PInfo.Direction.indexOf('<![CDATA[') > 0)
                    this.item.PInfo.Direction = this.item.PInfo.Direction.replace('<![CDATA[', '').replace(']]>', '');
            }
            catch (e) {
            }
            if (this.item.QType == "Essay")
                this.item.UserRepsonse = this.item.Correct;
            $(this.elRef.nativeElement).attr({
                "pid": (this.item.PInfo != null) ? this.item.PInfo.PassageCode : "",
                "maxscore": this.item.Score,
                "secid": this.item.section.SectionID,
                "id": '_' + this.item.ID,
                "iscorrect": "",
                "questiontype": this.item.QType,
                "attended": this.item.UserRepsonse != null && this.item.UserRepsonse.length > 0 ? 'Y' : 'N', "evaluationmode": "", "isevaluated": "", "completionstatus": "", "lmsref": "",
                "iscs": this.item.QuestionAttributes != "" && this.item.QuestionAttributes != null && typeof (this.item.QuestionAttributes.QuestionInfo) != 'undefined' ? this.item.QuestionAttributes.QuestionInfo.Shuffle : "",
                "metadatavalue": this.item.MetaDataValue != null && this.item.MetaDataValue != "" ? this.item.MetaDataValue : "",
                "mathtype": typeof (this.item.QuestionAttributes.QuestionInfo) != 'undefined' && this.item.QuestionAttributes != null && this.item.QuestionAttributes != "" && (typeof (this.item.QuestionAttributes.QuestionInfo.ResponseScoringType) != 'undefined' && this.item.QuestionAttributes.QuestionInfo.ResponseScoringType != null) ? this.item.QuestionAttributes.QuestionInfo.ResponseScoringType.toLowerCase() : ""

            });
        }
        catch (e) {  
        }
    }
    ngAfterViewInit() {
        try {
            if (this.test.TestInfo.AssessmentTypeCode == "SELADAPTIVE" && this.test.TestInfo.Status == 0) {
                if (typeof (this.test.isAdaptiveQuestionReceived) == 'undefined' || this.test.isAdaptiveQuestionReceived == false)
                    Number($(this.elRef.nativeElement).attr("secid")) == this.test.ActiveSectionId ? this.test.isAdaptiveQuestionReceived = true : this.test.isAdaptiveQuestionReceived = false;
            }
            if (typeof (this.test) != 'undefined' && typeof (this.test.isHtmlRendered) != 'undefined' && this.test.isHtmlRendered) {
                let TargetSectionID;
                if (this.test.isTimeOut && this.test.isPreviuousSectionTimeOut)
                    TargetSectionID = this.test.GetTargetSectionId();
                else
                    TargetSectionID = Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber + 1);
                Test.QuestionList = $("div[type='Question']", $("#divMainContent"));
                this.test.IntializeMoveArray(Test.QuestionList, Test.QuestionList.length - 1, Test.TestInfo.CurrentPageNumber);
                Test.QuestionInfo.children.push(this.item.ID);
                this.test.IntializeMoveArray(Test.QuestionInfo.children, Test.QuestionList.length - 1, Test.TestInfo.CurrentPageNumber);
                Test.AddQuestionInfo(Test.QuestionList[Test.TestInfo.CurrentPageNumber].id.substring(1), Test.TestInfo.CurrentPageNumber, Test.QuestionList[Test.TestInfo.CurrentPageNumber].getAttribute("maxScore"), '', Test.QuestionList[Test.TestInfo.CurrentPageNumber].getAttribute("AudioId"), Test.QuestionList[Test.TestInfo.CurrentPageNumber].getAttribute("Attended"), Test.QuestionList[Test.TestInfo.CurrentPageNumber].attributes["questionType"].value, Test.QuestionList[Test.TestInfo.CurrentPageNumber].getAttribute("lmsRef"), ((Test.QuestionList[Test.TestInfo.CurrentPageNumber].attributes["evaluationmode"] != null) ? Test.QuestionList[Test.TestInfo.CurrentPageNumber].attributes["evaluationmode"].value : null), false, false, ((Test.QuestionList[Test.TestInfo.CurrentPageNumber].attributes["completionstatus"] != null) ? Test.QuestionList[Test.TestInfo.CurrentPageNumber].attributes["completionstatus"].value : null), Test.QuestionList[Test.TestInfo.CurrentPageNumber].getAttribute("secid"), (Test.QuestionList[Test.TestInfo.CurrentPageNumber].attributes["metadatavalue"].value != null) ? Test.QuestionList[Test.TestInfo.CurrentPageNumber].attributes["metadatavalue"].value : null, Test.QuestionList[Test.TestInfo.CurrentPageNumber].IsHintsClicked)
                if (!this.test.isTimeOut && !this.test.isPreviuousSectionTimeOut)
                    this.test.CallClickEvents();
                TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                TestFunctions.ClosePopUp();
                var questionDiv = $("#_" + this.item.ID)[0];
                if (this.test.IsSectionChanged) {
                    this.test.pageNo = 1; this.test.IsSectionChanged = false;
                }
                if (this.test.isPreviuousSectionTimeOut) {
                    this.test.UpdateResponse(this.item.ID, 1, questionDiv);
                }
                else if (this.test.isTimeOut && !this.test.isPreviuousSectionTimeOut) {
                    this.test.UpdateResponse(this.item.ID, 2, questionDiv);
                }
                else
                    Navigation.ChangeTargetSection();
                Test.Section.ActiveSectionID = 'AMS_' + $(questionDiv).attr("secid");
                Test.TestInfo.CurrentGUID = this.item.ID;
				 if (this.test.pageNo == 1) {
                // When the section changes, in GetAdaptiveSectionQuestion call, we get next questionID of next section to be displayed. To store this detail we have put this condition
                //Storing these values is helpful when the session gets timeout, just after section changes
                try {
                    if (Test.Section.ActiveSectionID != '' && Test.TestInfo.CurrentGUID != '') {
                        this.assessmentService.UpdateCurrentDetails(Test.Section.ActiveSectionID, Test.TestInfo.CurrentGUID).subscribe(result => {
                            var reponseData: any;
                            reponseData = result;
                            if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                            }
                        });
                    }
                }
                catch (ex)
                { }
            }
                $("#lblCurrentSecName").html(Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName);
                this.test.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                if ($(".quesNo") != null) $(".quesNo").html(this.test.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
                if (this.test.totalQuestionCount == Test.TestInfo.CurrentPageNumber)
                    $("#btnNext").css('visibility', 'visible');
                else
                    $("#btnNext").css('visibility', 'visible');
                if (TargetSectionID != Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber) && !this.test.isPreviuousSectionTimeOut)
                    this.test.ShowSectionInstructionOnEachCompleteSection();
                else if (this.test.isPreviuousSectionTimeOut && Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted == Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions)
                    this.test.ShowSectionInstructionOnEachCompleteSection();
                return;
            }
            if (this.test.TestInfo.Status == 2 && this.test.TestInfo.IsViewSolution) {
				if (typeof (this.test.TestInfo.AssessmentTypeCode) != "undefined" && this.test.TestInfo.AssessmentTypeCode != null && this.test.TestInfo.AssessmentTypeCode == "SELADAPTIVE") 
					this.test.EvaluateUserReviewReponse(this.elRef.nativeElement, this.item);
				else
					this.test.EvaluateUserReponse(this.elRef.nativeElement, this.item);				
                this.test.AddQuestionInfo(this.item.ID, 1, this.item.QType, this.item.IsBookMarked, false, "", this.item.TimeSpent, this.item.MetaDataValue, this.item.IsHintsClicked);
            }
			 if (typeof (this.test) != 'undefined' && typeof (this.test.QItems) != 'undefined' && this.test.QItems.length - 1 == this.quesNo && this.test.TestInfo.Status == 2) 
			 {
				if (!this.test.TestInfo.IsViewSolution && this.test.Preferences.StylesheetName.toLocaleLowerCase() == "deepblue") {
					alert("Review is not enabled for this test,Please enable and continue");
					location.href = "TestReview.aspx";
				}
				this.test.Test.QuestionList = $("div[type='Question']", $("#divMainContent"));
				this.test.Test.QuestionList[this.test.mnpageNo - 1].style.display = "block";
				$(".btnforSectionsinstr").show();
				$("#timerHolder").hide();
				this.test.endPageNo = this.test.solutionSectionInfo[this.test.QItems[this.test.mnpageNo - 1].section.SectionID].QuestionCount;
				this.test.pageNo = this.test.mnpageNo;
				$(".quesNo").html(this.test.mnpageNo + "/" + this.test.endPageNo);
				$("#lblEndSection").html(this.test.solutionSectionInfo[this.test.QItems[this.test.mnpageNo - 1].section.SectionID].SectionName);
				$("#lblEndSection").show();
				if (this.test.solutionSectionInfo[this.test.QItems[this.test.mnpageNo - 1].section.SectionID].SectionName == 'Analytical Writing Assessment') {
					$("#reviewAns").hide();
					$("#reviewCrt").hide();
				}
				else {
					$("#reviewAns").show();
					$("#reviewCrt").show();
				}
				if ($(".RevSecFlag").length > 0 && this.test.Test.QuestionInfo[this.test.QItems[this.test.mnpageNo - 1].ID].IsMarked) {
					this.test.bookMarkElement = $(".RevSecFlag").find('span')[0];
					$(this.test.bookMarkElement).addClass("BookMarkImg");
					$(this.test.bookMarkElement).css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
				}           
			 }
            if (typeof (this.test) != 'undefined' && typeof (this.test.QItems) != 'undefined' && this.test.QItems.length - 1 == this.quesNo && this.test.TestInfo.Status != 2) {

                if (typeof (this.test.TestInfo.AssessmentTypeCode) != "undefined" && this.test.TestInfo.AssessmentTypeCode != null && this.test.TestInfo.AssessmentTypeCode == "SELADAPTIVE") {
                    if (typeof (this.test.isAdaptiveQuestionReceived) != 'undefined' && typeof (this.test.ActiveSectionId) != 'undefined' && !this.test.isAdaptiveQuestionReceived && (this.test.TestInfo.Status == 0 || this.test.TestInfo.Status == 1)) {
                        try {
                        alert("ErrorCode- ES004. The Practice Exam you are trying to take is unavailable at this time. Please try again later.");
                        this.test.ReturnToHomeDashboard();
                        return;						
                         }
                        catch (ex) {
                            window.close();
                            return;
                        }
                    }
                }
				 if (this.test.TestInfo.Status == 0) {
                try {
                    this.assessmentService.UpdateTestStatus().subscribe(result => {
                        var reponseData: any;
                        reponseData = result;
                        if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                        }
                    });
                }
                catch (ex)
                { }
            }
            if (typeof (InitializeObjects) == 'function')
			 InitializeObjects(mnClient, mnLeftLogo, mnRightLogo);
			 else {
                try {
                    alert("Unable to launch the exam now. Please click OK to go back to dashboard and launch the exam again.");
                    this.test.ReturnToHomeDashboard();
                    return;
                }
                catch(ex) {
                    this.test.ReturnToHomeDashboard();
                    return;
                }
            }
                
                SetUI_Controls();
                if (typeof (RB_UIMgnt) != "undefined") RB_UIMgnt.InitalizeScrollForNavigationPanel();
                if (this.test.Preferences.StylesheetName.toLocaleLowerCase() == "dodgerblue")
                    InitializeMainJS();
                if (Test.QuestionList.length == Test.TestInfo.QuestionsPerPage) this.test.isEnableSubmitButton = true;
                if (Test.TestInfo.AssessmentTypeCode != "SELADAPTIVE" && Test.TestInfo.QuestionsPerPage == Test.QuestionList.length && !Test.TestInfo.IsEvaluateResponse) { $("#lowerStrip").show(); $("#btnNext").hide(); $("#btnPrev").hide(); if ($("article").length > 0) $("article").addClass("article_allquestions"); }                    
				if(Test.TestInfo.AssessmentTypeCode == "SSET" || Test.TestInfo.AssessmentTypeCode == "HS"){if (Test.TestInfo.CurrentPageNumber == Test.QuestionList.length && !Test.TestInfo.IsEvaluateResponse) this.test.isEnableSubmitButton = false;}
				else{if (Test.TestInfo.CurrentPageNumber == Test.QuestionList.length && !Test.TestInfo.IsEvaluateResponse) this.test.isEnableSubmitButton = true;}

                if (typeof (Test.TestInfo.AssessmentTypeCode) != "undefined" && Test.TestInfo.AssessmentTypeCode != null && Test.TestInfo.AssessmentTypeCode == "SELADAPTIVE" && this.test.TestInfo.Status == 1) {
                    this.test.CheckPreviousSectionTimeout();
                    if (this.test.isPreviuousSectionTimeOut) {  //handling alt f4 scenario.
                        this.test.TargetSectionId = Test.Section.ActiveSectionID;
                        this.test.ActiveSectionId = Test.Section.ActiveSectionID;
                    }
                }
                this.test.HandleBookmarkedStatus();
               Test.TestInfo.TimeRemaining = Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail;
				 if (this.test.TestInfo.Status == 0) {
                try {
                    hlrUpdateTimeAvail();
                    if (Test.Section.ActiveSectionID != '' && Test.TestInfo.CurrentGUID != '') {
                        this.assessmentService.UpdateCurrentDetails(Test.Section.ActiveSectionID, Test.TestInfo.CurrentGUID).subscribe(result => {
                            var reponseData: any;
                            reponseData = result;
                            if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                            }
                        });
                    }
                }
                catch (ex)
                { }
            }
                this.test.timeoutTimer = setInterval(() => { this.test.CallBackFunctionForTimeUpdate(); }, 1000);
                this.test.pageNo = Test.TestInfo.CurrentPageNumber;
                this.test.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                if (this.test.TestInfo.Status == 1) {
                      if(Test.TestInfo.AssessmentTypeCode == "SSET" || Test.TestInfo.AssessmentTypeCode == "HS"){
                        this.test.pageNo = Test.TestInfo.CurrentPageNumber - (Test.Section.SectionInfo[Test.Section.ActiveSectionID].SPNo-1);
                    }
                    else{
                        Test.QuestionInfo[Test.TestInfo.CurrentGUID].IsAnswered == 1 ? this.test.pageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted : this.test.pageNo = Number(Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted + 1);
                    }  
					this.test.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions;
                    if (this.test.pageNo == 1) $("#btnPrev").css('visibility', 'hidden');
                }
                if ($(".quesNo").length > 0) $(".quesNo").html(this.test.pageNo + "&nbsp;of&nbsp;" + this.test.endPageNo);
                if (this.test.endPageNo == Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo)
                    $("#btnNext").css('visibility', 'visible');
                var CurerntsectionName = Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName.toLocaleLowerCase();
                if (CurerntsectionName.indexOf('integrated reasoning') != -1)
                    this.test.isActiveIrSection = true;
            }
            else if (typeof (this.test) != 'undefined' && typeof (this.test.QItems) != 'undefined' && this.test.QItems.length - 1 == this.quesNo && this.test.TestInfo.Status == 2) {
                if (!this.test.TestInfo.IsViewSolution && this.test.Preferences.StylesheetName.toLocaleLowerCase() == "deepblue") {
                    alert("Review is not enabled for this test,Please enable and continue");
                    location.href = "TestReview.aspx";
                }
                this.test.Test.QuestionList = $("div[type='Question']", $("#divMainContent"));
                if (this.test.Test.QuestionList.length > 1) this.test.IsShowNextReviewButton = true;
                this.test.Test.QuestionList[this.test.mnpageNo - 1].style.display = "block";
                $(".btnforSectionsinstr").show();
                $("#timerHolder").hide();
                this.test.endPageNo = this.test.solutionSectionInfo[this.test.QItems[this.test.mnpageNo - 1].section.SectionID].QuestionCount;
                this.test.pageNo = this.test.mnpageNo;
                $(".quesNo").html(this.test.mnpageNo + "/" + this.test.endPageNo);
                $("#lblEndSection").html(this.test.solutionSectionInfo[this.test.QItems[this.test.mnpageNo - 1].section.SectionID].SectionName);
                $("#lblEndSection").show();
                if ($(".RevSecFlag").length > 0 && this.test.Test.QuestionInfo[this.test.QItems[this.test.mnpageNo - 1].ID].IsMarked) {
                    this.test.bookMarkElement = $(".RevSecFlag").find('span')[0];
                    $(this.test.bookMarkElement).addClass("BookMarkImg");
                    $(this.test.bookMarkElement).css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
                }
            }
        }
        catch (e) { 
            console.log("Error in displaying test questions. Page: taketestdirective Method: ngAfterViewInit Error: " + e.message);
        }
    }
}

@Directive({
    selector: '[cpDefaultTheme]'

})
export class DefaultThemeDirective implements OnInit {
    @Input('cpDefaultTheme') item: any;

    constructor(private elRef: ElementRef) {
        this.highlight("red");
    }

    @HostListener('mouseenter') onMouseEnter() {

    }

    @HostListener('mouseleave') onMouseLeave() {
        this.highlight(null);
    }
    @HostListener('click', ['$event']) onClick($event) {
        this.highlight("red");
    }

    private highlight(color: string) {
        this.elRef.nativeElement.style.backgroundColor = color;
    }
    ngOnInit() {
    }
}

//Format fib drag and drop questions


//<div id="AMS_6b2deed2-08a7-415e-8dfc-667a36c1e273_1_Drop" name= "AMS_6b2deed2-08a7-415e-8dfc-667a36c1e273" title= "blanks" class="blankDiv ui-droppable" onclick= "FunctionCall(48,this,3,1,'')" blankdiv= "true" droppable= "true" > </div>

@Directive({ selector: '[ConstructFibDnd]' })
export class ConstructFibDndDirective implements OnInit, AfterViewInit {
    @Input('ConstructFibDnd') item: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        try {
            if (this.item.CorrectOptions == null) {
                if (this.item.UserRepsonse != null) {
                    for (var res = 0; res < this.item.UserRepsonse.length; res++) {
                        for (var ch = 0; ch < this.item.Choices.length; ch++) {
                            if (this.item.Choices[ch].Ident == this.item.UserRepsonse[res].split(':')[1])
                                this.item.Text = this.item.Text.replace("@^^Blank_" + this.item.UserRepsonse[res].split(':')[0] + "^^@", "<div id=" + this.item.Choices[ch].ID + "\_Drop  name=" + this.item.ID + "  title=\"blanks\"  class=\"blankDiv ui- droppable\" onclick=\"FunctionCall(48, this, 3, 1, '')\" blankdiv= \"true\" droppable= \"true\" ><a achoice=\"true\" href=\"#\" style=\"color:#000000;text - decoration:none; display: block; text - align: center; \" ng-reflect-safe-html=" + this.item.Choices[ch].Text + " id=" + this.item.Choices[ch].Ident + "_Drag\" choiceid=" + this.item.Choices[ch].Ident + "> " + this.item.Choices[ch].Text + "</a> </div>");
                        }
                    }
                }
                if (this.item.Text.indexOf('@^^Blank') != -1) {
                    for (var ch = 0; ch < this.item.Choices.length; ch++) {
                        this.item.Text = this.item.Text.replace("@^^Blank_" + this.item.Choices[ch].ID + "^^@", "<div id=" + this.item.Choices[ch].ID + "\_Drop  name=" + this.item.ID + "  title=\"blanks\"  class=\"blankDiv ui- droppable\" onclick=\"FunctionCall(48, this, 3, 1, '')\" blankdiv= \"true\" droppable= \"true\" > </div>");
                    }
                }
            }
        }
        catch (ex) { }
    }
    ngAfterViewInit() {
        this.eleRef.nativeElement.innerHTML = this.item.Text;
    }
}

//Slider html5

@Directive({ selector: '[sliderDiv]' })
export class sliderDivDirective implements OnInit {
    @Input('sliderDiv') item: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        try {
            if (this.item.QuestionAttributes != null && typeof (this.item.QuestionAttributes) != 'undefined')
                this.item.QuestionAttributes = JSON.parse(this.item.QuestionAttributes);
        }
        catch (ex) { }
        $(this.eleRef.nativeElement).attr({
            "minvalue": this.item.QuestionAttributes.QuestionInfo.LowerBound,
            "maxvalue": this.item.QuestionAttributes.QuestionInfo.UpperBound,
            "stepvalue": this.item.QuestionAttributes.QuestionInfo.Step,
            "startvalue": this.item.QuestionAttributes.QuestionInfo.LowerBound
        })
        if (this.item.UserRepsonse != null) {
            this.eleRef.nativeElement.setAttribute('startvalue', this.item.UserRepsonse[0]);
        }
    }
}

//format image labelling questions

@Directive({ selector: '[ConstructImageLabling]' })
export class ConstructImageLablingDirective implements OnInit {
    @Input('ConstructImageLabling') item: any;
    @Input('considerident') value: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        var imageAttributes = this.item.ImageSource.split(',');
        try {
            if (imageAttributes.length > 1) {
                this.item.ImageSource = imageAttributes[0];
                this.item.ImageWidth = imageAttributes[1];
                this.item.ImageHeight = imageAttributes[2];
            }
        }
        catch (ex) { }
        for (var i = 0; i < this.item.Choices.length; i++) {
            for (var ch = 0; ch < this.item.QuestionAttributes.ChoiceInfo.length; ch++) {
                switch (this.value) {
                    case 0:
                        if (this.item.Choices[i].Ident == this.item.QuestionAttributes.ChoiceInfo[ch].Ident) {
                            this.item.Choices[i].XAxis = this.item.QuestionAttributes.ChoiceInfo[ch].Xaxis
                            this.item.Choices[i].YAxis = this.item.QuestionAttributes.ChoiceInfo[ch].Yaxis
                        }
                        break;
                    case 1:
                        if (this.item.Choices[i].ID == this.item.QuestionAttributes.ChoiceInfo[ch].Ident) {
                            this.item.Choices[i].XAxis = this.item.QuestionAttributes.ChoiceInfo[ch].Xaxis
                            this.item.Choices[i].YAxis = this.item.QuestionAttributes.ChoiceInfo[ch].Yaxis
                        }
                        break;
                    case 3:
                        if (this.item.Choices[i].Text == this.item.QuestionAttributes.ChoiceInfo[ch].Ident) {
                            this.item.Choices[i].XAxis = this.item.QuestionAttributes.ChoiceInfo[ch].Xaxis
                            this.item.Choices[i].YAxis = this.item.QuestionAttributes.ChoiceInfo[ch].Yaxis
                        }
                        break;
                }

            }

        }

    }
}


//format the fill in the  blank questions
@Directive({ selector: '[ConstructFib]' })
export class ConstructFibDirective implements OnInit {
    @Input('ConstructFib') item: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        for (var ch = 0; ch < this.item.QuestionAttributes.ChoiceInfo.length; ch++)
            try {

                if (this.item.UserRepsonse != null) {
                    for (var res = 0; res < this.item.UserRepsonse.length; res++) {
                        if (this.item.QuestionAttributes.ChoiceInfo[ch].Ident == this.item.UserRepsonse[res].split(':')[0])
                            this.item.Text = this.item.Text.replace("@^^Blank_" + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + "^^@", "<input type=\"text\" onkeypress=\"FunctionCall(28, 'String', this, null, event);\"" + "name=" + this.item.ID + '$' + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + " id=" + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + " question=\"true\" type=\"text\" size=" + this.item.QuestionAttributes.ChoiceInfo[ch].Maxchars + " maxlength=" + this.item.QuestionAttributes.ChoiceInfo[ch].Maxchars + " value=\"" + this.item.UserRepsonse[res].split(':')[1] + "\" >");
                    }
                    this.item.Text = this.item.Text.replace("@^^Blank_" + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + "^^@", "<input type=\"text\" onkeypress=\"FunctionCall(28, 'String', this, null, event);\"" + "name=" + this.item.ID + '$' + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + " id=" + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + " question=\"true\" type=\"text\" size=" + this.item.QuestionAttributes.ChoiceInfo[ch].Maxchars + " maxlength=" + this.item.QuestionAttributes.ChoiceInfo[ch].Maxchars + " value=\"\" >");
                }
                else
                    this.item.Text = this.item.Text.replace("@^^Blank_" + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + "^^@", "<input type=\"text\" onkeypress=\"FunctionCall(28, 'String', this, null, event);\"" + "name=" + this.item.ID + '$' + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + " id=" + this.item.QuestionAttributes.ChoiceInfo[ch].Ident + " question=\"true\" type=\"text\" size=" + this.item.QuestionAttributes.ChoiceInfo[ch].Maxchars + " maxlength=" + this.item.QuestionAttributes.ChoiceInfo[ch].Maxchars + " value=\"\" >");

            }
            catch (ex) { }

    }
}
//format the   select a blank questions
@Directive({ selector: '[ConstructSAB]' })
export class ConstructSABDirective implements OnInit {
    @Input('ConstructSAB') item: any;
    @Input('first') choiceItem: any;
    @Input('second') test: any;
    public ShuffleOptions: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        try {
            var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
            var counter = 0, isCheckMax = false, isSelcted = false, isAdded = false, choiceText = "";
            var isShuffle = this.item.QuestionAttributes != "" && this.item.QuestionAttributes != null && typeof (this.item.QuestionAttributes.QuestionInfo) != 'undefined' ? this.item.QuestionAttributes.QuestionInfo.Shuffle : "";
            this.ShuffleOptions = () => {
                var temRandomChoiceOptions = this.test.GetRandomChoiceArray(this.choiceItem.Options.length - 1)
                if ($.inArray(0, temRandomChoiceOptions) == -1) temRandomChoiceOptions.push(0);
                for (var i = 0; i < temRandomChoiceOptions.length - 1; i++) {
                    if (this.item.UserRepsonse != null) {
                        for (var res = 0; res < this.item.UserRepsonse.length; res++) {
                            if (this.choiceItem.Options[temRandomChoiceOptions[i]].ID == this.item.UserRepsonse[res].split(':')[0] && this.choiceItem.Options[temRandomChoiceOptions[i]].Ident == this.item.UserRepsonse[res].split(':')[1])
                                isSelcted = true;
                        }
                    }
                    if (counter == 0) {
                        counter++;
                        choiceText = '<select id="' + this.choiceItem.Options[temRandomChoiceOptions[i]].ID + '" name="' + this.item.ID + '" question="true"   onchange="FunctionCall(11, this);">';
                        choiceText += "<option value=\"\"></option>"
                    }
                    if (isSelcted && !isAdded) {
                        choiceText += '<option selected value="' + this.choiceItem.Options[temRandomChoiceOptions[i]].ID + ':' + alphabet[i] + '">' + this.choiceItem.Options[temRandomChoiceOptions[i]].Ident + '</option>'
                        isAdded = true;
                    }
                    else
                        choiceText += '<option value="' + this.choiceItem.Options[temRandomChoiceOptions[i]].ID + ':' + alphabet[i] + '">' + this.choiceItem.Options[temRandomChoiceOptions[i]].Ident + '</option>'

                }
            }
            if (isShuffle == 'Yes')
                this.ShuffleOptions();
            else {
                for (var i = 0; i < this.choiceItem.Options.length; i++) {
                    if (this.item.UserRepsonse != null) {
                        for (var res = 0; res < this.item.UserRepsonse.length; res++) {
                            if (this.choiceItem.Options[i].ID == this.item.UserRepsonse[res].split(':')[0] && this.choiceItem.Options[i].Ident == this.item.UserRepsonse[res].split(':')[1])
                                isSelcted = true;
                        }
                    }

                    if (counter == 0) {
                        counter++;
                        var choiceText = '<span><select id="' + this.choiceItem.Options[i].ID + '"  name="' + this.item.ID + '" question="true"   onchange="FunctionCall(11, this);">';
                        choiceText += "<option value=\"\"></option>"
                    }
                    if (isSelcted && !isAdded) {
                        choiceText += '<option selected value="' + this.choiceItem.Options[i].ID + ':' + alphabet[i] + '">' + this.choiceItem.Options[i].Ident + '</option>'
                        isAdded = true;
                    }
                    else
                        choiceText += '<option value="' + this.choiceItem.Options[i].ID + ':' + alphabet[i] + '">' + this.choiceItem.Options[i].Ident + '</option>'

                }
            }
            choiceText += '</select></span>'
            this.item.Text = this.item.Text.replace('@^^Blank_', " ").replace('^^@', " ")
            this.item.Text = this.item.Text.replace(this.item.Text.substr(this.item.Text.indexOf(this.choiceItem.ID), this.choiceItem.ID.length), choiceText)
        }
        catch (ex) {
        }

    }

}

//format the   select a blank questions
@Directive({ selector: '[ConstructSectionQues]' })
export class ConstructSectionQuesDirective implements OnInit {
    @Input('ConstructSectionQues') section: any;
    ngOnInit() {
        this.section.QuestionsNavList = [];
        for (var i = this.section.spNo; i <= this.section.epNo; i++) {
            if (i == 0) continue;
            this.section.QuestionsNavList.push(i);
        }
    }
}

//contsruct the sequence question choices
@Directive({
    selector: '[ConstructSequenceChoices]'
})
export class ConstructSequenceChoicesDirective implements OnInit {
    @Input('ConstructSequenceChoices') choice: any;
    @Input('sequenseItem') item: any;
    @Input('second') test: any;
    ngOnInit() {
        this.choice.ChoiceList = [];
        if (this.item.Correct != null) {
            if (this.choice.Ident != 'WrongAnswer') {
                var choceId = this.choice.ID;
                var ChoicesarrList = this.choice.Text.split('§');
                for (var i = 0; i < ChoicesarrList.length; i++) {
                    for (var j = 0; j < this.item.Correct.split(',').length; j++) {
                        var Choice = ChoicesarrList[j].split('@^^@');
                        if (ChoicesarrList[j].split('@^^@')[1] == this.item.Correct.split(',')[i]) {
                            var choiceObj = {
                                Text: Choice[0], Ident: Choice[1], ID: choceId, Position: j + 1
                            }
                            this.choice.ChoiceList.push(choiceObj);
                        }
                    }
                }
            }
        }
        else if (this.choice.Ident != 'WrongAnswer') {
            var choceId = this.choice.ID;
            var ChoicesarrList = this.choice.Text.split('§');
            for (var i = 0; i < ChoicesarrList.length; i++) {
                var Choice = ChoicesarrList[i].split('@^^@');
                if (ChoicesarrList[i].split('@^^@').length > 1) {
                    var choiceObj = {
                        Text: Choice[0], Ident: Choice[1], ID: choceId, Position: i + 1
                    }
                    this.choice.ChoiceList.push(choiceObj);
                }
            }
        }
    }
}
/*Passage construction*/

@Directive({
    selector: '[reSize]'
})
export class ReSizeDirective implements AfterViewInit {
    @Input('reSize') item: any;
    @Input('first') val: any;
    constructor(private eleRef: ElementRef, private objTakeTest: TaketestComponent) {
    }
    ngAfterViewInit() {
        $(this.eleRef.nativeElement).attr({
            "pid": (this.item.PInfo != null) ? this.item.PInfo.PassageCode : ""
        });

    }
}
@Directive({
    selector: '[passageHtml]'
})
export class PassageHtmlDirective implements OnInit, AfterViewInit {
    @Input('passageHtml') item: any;
    constructor(private eleRef: ElementRef) {
    }
    ngOnInit() {
        this.eleRef.nativeElement.innerHTML = this.item.PInfo.PassageXml;
    }
    ngAfterViewInit() {
        try {
            if (this.item.QuestionPreferences != "" && typeof (this.item.QuestionPreferences) != 'undefined' && this.item.QuestionPreferences != null) {
                this.item.QuestionPreferences = JSON.parse(this.item.QuestionPreferences);
            }
            if (this.item.QuestionPreferences != "" && typeof (this.item.QuestionPreferences) != 'undefined' && this.item.QuestionPreferences != null) {
                if (typeof (this.item.QuestionPreferences.length) == 'undefined' && typeof (this.item.QuestionPreferences.ID) == 'string')
                    $('span[id="' + this.item.QuestionPreferences.ID + '"]', $(this.eleRef.nativeElement)).css("background-color", this.item.QuestionPreferences.Value)
                else {
                    for (var i = 0; i < this.item.QuestionPreferences.length; i++) {
                        $('span[id="' + this.item.QuestionPreferences[i].ID + '"]', $(this.eleRef.nativeElement)).css("background-color", this.item.QuestionPreferences[i].Value)
                    }
                }
            }
        }
        catch (ex) { }
    }
}

@Directive({
    selector: '[addQuestionLevelTime]'
})
export class AddQuestionLevelTimeDirective implements OnInit {
    @Input('addQuestionLevelTime') item: any;
    constructor(private eleRef: ElementRef) {
    }
    ngOnInit() {
        try {
            if (this.item.QuestionAttributes != '' && this.item.QuestionAttributes.length > 0)
                $(this.eleRef.nativeElement).val('P0Y0M0DT0H0M' + this.item.QuestionAttributes.QuestionInfo.Duration + 'S');
            else
                $(this.eleRef.nativeElement).val('P0Y0M0DT0H0M0S');
        }
        catch (ex) { }
    }
}
@Directive({
    selector: '[onCreate]'
})
export class OnCreate {
    @Output() onCreate: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }
    ngOnInit() {
        this.onCreate.emit('');
    }

}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/app.taketestdirective.ts